(() => {
  if (window.lcSizeGuideEventsReady) return;
  window.lcSizeGuideEventsReady = true;
  const openers = new WeakMap();

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('.lc-size-guide__trigger');

    if (trigger) {
      const dialog = trigger.closest('lc-size-guide')
        ?.querySelector('.lc-size-guide__dialog');

      if (!(dialog instanceof HTMLDialogElement)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openers.set(dialog, trigger);

      if (!dialog.open) dialog.showModal();
      return;
    }

    const dialog = event.target.closest('.lc-size-guide__dialog');

    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;

    event.stopImmediatePropagation();

    if (event.target.closest('.lc-size-guide__close')) {
      event.preventDefault();
      dialog.close();
      return;
    }

    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();

      if (
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom
      ) {
        dialog.close();
      }
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (
      event.key !== 'Escape' ||
      !(event.target instanceof Element)
    ) return;

    const dialog = event.target.closest('.lc-size-guide__dialog[open]');

    if (!(dialog instanceof HTMLDialogElement)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    dialog.close();
  }, true);

  document.addEventListener('close', (event) => {
    const dialog = event.target;

    if (
      !(dialog instanceof HTMLDialogElement) ||
      !dialog.matches('.lc-size-guide__dialog')
    ) return;

    const trigger = openers.get(dialog);

    if (trigger?.isConnected) {
      trigger.focus({ preventScroll: true });
    }

    openers.delete(dialog);
  }, true);
})();